import {
  REMOVE_SELECTED_EQUEUE,
  SELECT_EQUEUE,
  SET_SELECTED_EQUEUE,
  SET_SELECTED_EQUEUE_FAILED,
} from "./types";
import { panels, SELECT_EQUEUE_ADDRESS } from "../../variables";
import {
  hideSelectedEqueueLoader,
  showSelectedEqueueLoader,
} from "./loaderActions";
import { checkErrorStatusAndExecuteCallback } from "../../utils";
import {
  restartPanelsHistory,
  setActivePanel,
  setPreviousPanel,
} from "./panelsActions";
import { hideBookingLoader, hideConfirmLoader } from "./loaderActions";

import { equeueBookingSuccess } from "./equeuesActions";

import store from "../store";
import { setMetrics } from "../../helpers/metrics";
import Api from "../../api";
import { HealthCheckEvents } from "../../api/types";

export const selectEqueue = (id) => {
  return {
    type: SELECT_EQUEUE,
    payload: id,
  };
};

export const selectEqueueLoadingStart = (id, counter404 = 0, isRedirect) => (
  dispatch
) => {
  const healthCheckInstance = Api.healthCheckFor(HealthCheckEvents.getBooking);
  const apiBase = store.getState().addresses.apiBase;

  dispatch(showSelectedEqueueLoader());
  Api.instance.get(SELECT_EQUEUE_ADDRESS + id, {
    method: "get",
  })
    .then((response) => {
      const body = response.data;
      dispatch(setSelectedEqueue(body));
      healthCheckInstance.sendSuccess();
      if (isRedirect) {
        dispatch(equeueBookingSuccess());
        dispatch(hideConfirmLoader());
        dispatch(hideBookingLoader());
        dispatch(restartPanelsHistory());
      }
    })
    .catch((error) => {
      healthCheckInstance.sendFailure({ browserError: error.message });
      const COUNT = 8;
      if (error?.response?.status === 404) {
        // @TODO. костыль. Если севере возвращает 404, пытаемся сделать запрос снова, т.к. если сразу же после
        // создания записи запросить данные, сервер возвращает 404.
        if (counter404 < COUNT) {
          window.setTimeout(() => {
            dispatch(selectEqueueLoadingStart(id, counter404 + 1, isRedirect));
          }, 700);
          return;
        }
        if (counter404 === COUNT) {
          setMetrics("reachGoal", "OldHeath.BookingDetailsError");
          dispatch(hideConfirmLoader());
          dispatch(setPreviousPanel());
          dispatch(setActivePanel(panels.error));
        }
      }
      setMetrics("reachGoal", "OldHeath.BookingDetailsError");
      dispatch(setSelectedEqueueFailed(error));
      checkErrorStatusAndExecuteCallback(error, () =>
        dispatch(setActivePanel(panels.error))
      );
    })
    .finally(() => dispatch(hideSelectedEqueueLoader()));
};

export const setSelectedEqueueFailed = (e) => {
  return {
    type: SET_SELECTED_EQUEUE_FAILED,
    payload: {
      error: e,
    },
  };
};
export const setSelectedEqueue = (equeue) => {
  return {
    type: SET_SELECTED_EQUEUE,
    payload: equeue,
  };
};

export const removeSelectedEqueue = () => {
  return {
    type: REMOVE_SELECTED_EQUEUE,
  };
};
